export default "__VITE_ASSET__f22256a4__"